<div class="settings-container">
  <settings-menu></settings-menu>
  <article class="settings-content">
    <router-outlet></router-outlet>
  </article>
</div>
